import {IActionBase} from "./IActionBase";

import React, {Component} from "react";

import {store} from "../../redux/storeConfig/store";
import {callPostService} from "../services/api_service";
import {ActionsManager} from "./actionsManager";
import {utils_ui} from "../utils/utils_ui";
import {store_PageData} from "../../redux/reducers/store_PageData/store_PageData";


export class executeQuery extends Component implements IActionBase {

    actionCode = "executeQuery";
    actionName = "executeQuery";

    Execute = (prmActionParameters:any, prmActionsManager?:ActionsManager, prmElementObj?:any, prmData?:any)=> {
        let queryName: string = prmActionParameters?.queryName || prmActionParameters?.QueryName; //prmActionParameters?.queryName;
        let sortBy: string = prmActionParameters?.sortBy

        if (!queryName) {
            queryName = "*";
        }

        let pageCode: string = prmActionParameters?.pageCode;

        if (!queryName) {
            queryName = "*";
        }

        let currPageNumber = 0

        if (!!prmActionParameters?.PageNumber) {
            currPageNumber = prmActionParameters?.PageNumber
        }
        else {
            try {
                let dicLastResponseObj = store.getState().store_PageData?.dicLastResponseObj;

                if (!!dicLastResponseObj
                    && !!dicLastResponseObj[queryName]) {
                    currPageNumber = dicLastResponseObj[queryName].PageNumber
                }
            }
            catch (e) {
                //comment: DO NOTHING
            }
        }

        let currPageSize = 0

        if (!!prmActionParameters?.PageSize) {
            currPageSize = prmActionParameters?.PageSize
        }
        else {
            try {
                let dicLastResponseObj = store.getState().store_PageData?.dicLastResponseObj;

                if (!!dicLastResponseObj
                    && !!dicLastResponseObj[queryName]) {
                    currPageSize = dicLastResponseObj[queryName].PageSize
                }
            }
            catch (e) {
                //comment: DO NOTHING
            }
        }

        // let currPageNumber = 0

        let currPageStruct = store.getState().store_PageStructure.pageStructure;

        if (!!currPageStruct && !!currPageStruct.LstDataRequests) {
            for (let ind01 = 0; ind01 < currPageStruct.LstDataRequests.length; ind01++) {
                let currDataRequestObj = currPageStruct.LstDataRequests[ind01];

                if (queryName == "*"
                    || currDataRequestObj.ResponseName == queryName) {
                    let dicFilters = utils_ui.getDicFilterValues(currDataRequestObj.ResponseName);

                    if (!pageCode) {
                        pageCode = currPageStruct.PageCode
                    }

                    let prmParamsObj = {
                        "ProjectID": currPageStruct.ProjectID,
                        "PageCode": pageCode,
                        "ResponseName": currDataRequestObj.ResponseName,
                        "PageNumber": currPageNumber,
                        "PageSize": currPageSize, //prmActionParameters?.PageSize ||
                        "SortBy": sortBy, //prmActionParameters?.PageSize ||
                        "DicFilterValues": dicFilters,
                        "LstFilters": []
                    }

                    localStorage[`QueryFilter_project_${prmParamsObj.ProjectID}_page_${prmParamsObj.PageCode}_query_${prmParamsObj.ResponseName}`] = JSON.stringify(dicFilters);

                    callPostService("clsSvc_DataRequest_Get", prmParamsObj).then((prmResponse: any) => {
                        if (!!prmResponse?.reponseObj?.Data) {
                            prmResponse.reponseObj.Data = utils_ui.parseAllDates(prmResponse?.reponseObj?.Data);

                            store.dispatch({type: 'SET_DATA',
                                projectID: prmParamsObj.ProjectID,
                                data: prmResponse?.reponseObj?.Data,
                                responseObj: prmResponse?.reponseObj});

                            if (!!prmActionParameters?.callbackFunction){
                                prmActionParameters.callbackFunction(prmResponse?.reponseObj)
                            }
                        }
                    })
                }
            }
        }

    }

}
